import { Label } from '@/components/ui/label'
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue
} from '@/components/ui/select'

type DropdownOption = {
    label: string;
    value: string;
};

type DropdownProps = {
    label?: string;
    options: DropdownOption[];
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    className?: string;
    id?: string;
    name?: string;
    disabled?: boolean;
};

export default function Dropdown({
    label,
    options,
    value,
    onChange,
    placeholder = 'Select',
    className = 'w-30 cursor-pointer',
    id,
    name,
    disabled = false
}: DropdownProps) {
    return (
        <div className="flex items-center gap-2">
            {label && (
                <Label htmlFor={id} className="text-sm font-medium">
                    {label}
                </Label>
            )}
            <Select name={name} value={value} onValueChange={onChange} disabled={disabled}>
                <SelectTrigger id={id} className={className}>
                    <SelectValue placeholder={placeholder} />
                </SelectTrigger>
                <SelectContent side="bottom">
                    {options.map((option) => (
                        <SelectItem key={option.value} value={option.value}>
                            {option.label}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </div>
    )
}
